/* istanbul ignore file */

export const REPORTING_EVENTS = {
  WIDGET_CLICKED: 'Widget Clicked',
  REPORT_SELECTED: 'Report Selected',
  NEW_REPORT_CLICKED: 'New Report Clicked',
  EDIT_REPORT_CLICKED: 'Edit Report Clicked',
  DELETE_REPORT_CLICKED: 'Delete Report Clicked',
  REPORT_SAVED: 'Report Saved',
  REPORT_DELETED: 'Report Deleted',
} as const

export type ReportingEventName =
  (typeof REPORTING_EVENTS)[keyof typeof REPORTING_EVENTS]
